import { render, staticRenderFns } from "./FFooter.vue?vue&type=template&id=fe231df6&scoped=true&"
import script from "./FFooter.vue?vue&type=script&lang=js&"
export * from "./FFooter.vue?vue&type=script&lang=js&"
import style0 from "./FFooter.vue?vue&type=style&index=0&id=fe231df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe231df6",
  null
  
)

export default component.exports